import { inject, injectable } from 'tsyringe';
import { CallTrackerResponse } from '@/modules/task/domain/call-tracking/trackers/CallTrackerResponse';
import type { CallTracker } from './CallTracker';
import type { Task } from '../../task/Task';
import type { Call } from '../../call/types/Call';
import type { EventTracker } from '../../tracking-event/EventTracker';
import { EventTrackerToken } from '../../../di/tokens';
import { TaskVisibilityChecker } from '../TaskVisibilityChecker';

@injectable()
export class CompleteInboundCallTracker implements CallTracker {
  constructor(
    @inject(EventTrackerToken)
    private readonly eventTracker: EventTracker,
    private readonly taskVisibilityChecker: TaskVisibilityChecker,
  ) {}

  track(call: Call, task: Task): CallTrackerResponse {
    if (!(call.isIncoming && call.isCompleted && this.taskVisibilityChecker.isVisible(task))) {
      return CallTrackerResponse.EventNotPublished;
    }

    this.eventTracker.publishSingularEvent('Call completed');

    if (call.isLongerThan5Minutes) {
      this.eventTracker.publishSingularEvent('Call completed above 5 minutes');
    }

    return CallTrackerResponse.EventPublished;
  }
}
